import { render, staticRenderFns } from "./SailingSchedule.vue?vue&type=template&id=3fb041bf"
import script from "./SailingSchedule.vue?vue&type=script&lang=js"
export * from "./SailingSchedule.vue?vue&type=script&lang=js"
import style0 from "./SailingSchedule.vue?vue&type=style&index=0&id=3fb041bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports